export class PwrDetails {
	newPass: string;
    ConfirmPass: string;
    TempId: string;
    OriginalPass: string;
    profileId: number;
}


// WEBPACK FOOTER //
// ./src/app/models/PwrDetails.ts